<script>
    export let title;
    export let text;
    export let href = null;
</script>

<style>
    h5  {
        margin-bottom: 0.5em;
        font-weight: bold;
    }
</style>

<h5>
    {#if href}
        <a href={href} target="_blank">
            { title }
        </a>
    {:else}
        { title }
    {/if}
</h5>

<p>
    {text}
</p>
